"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.StyledContentWrapper = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../utils");

/* eslint-disable react/prop-types */
var StyledContentWrapper = (0, _utils.withProps)()((0, _styledBase["default"])("div", {
  target: "e1yh3ng70"
})("\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n    ", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJpbmRleC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQtZGlzYWJsZSByZWFjdC9wcm9wLXR5cGVzICovXG5pbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuaW1wb3J0IHsgd2l0aFByb3BzIH0gZnJvbSBcIi4uLy4uLy4uL3V0aWxzXCI7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDb250ZW50V3JhcHBlciA9IHdpdGhQcm9wcygpKFxuICAgIHN0eWxlZC5kaXYoYFxuICAgICAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcblxuICAgIGApXG4pO1xuIl19 */"));
exports.StyledContentWrapper = StyledContentWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/RegionSelect/style/index.js
// module id = 2149
// module chunks = 6 7 17 18